// 1. New array added by "New class subject button" is called newArr
// newArr can be found in line 469
// api passed on 146,171,724,632,276
// table change 650
// change of label fields 432,458,519

import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsSubject, optionscumulative, optionsdesignation, optionsleavetype, roledrp } from '../../Helper'
import moment from 'moment'
import { leaveSetupApi } from '../../../utils/AdminDashApi/LeaveSetupApi'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'

const LeaveSetupComp = () => {
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  const [activefrom2,setactivefrom2] = useState("")
  const [activeto2,setactiveTo2] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")

  const [leavetypemod1,setleavetypemod1] = useState("")
  const [labelleavetypemod1,setlabelleavetypemod1] = useState("")
  const [borderleavetypemod1,setborderleavetypemod1] = useState("")

  const [descriptionmod1,setdescriptionmod1] = useState("")
  const [labeldescriptionmod1,setlabeldescriptionmod1] = useState("")
  const [borderdescriptionmod1,setborderdescriptionmod1] = useState("")

  const [designationmod1,setdesignationmod1] = useState("")
  const [borderdesignationmod1,setborderdesignationmod1] = useState("")
  const [labeldesignationmod1,setlabeldesignationmod1] = useState("")

  const [noofmonthmod1,setnoofmonthmod1] = useState("")
  const [labelnoofmonthmod1,setlabelnoofmonthmod1] = useState("")
  const [bordernoofmonthmod1,setbordernoofmonthmod1] = useState("")

  const [leavebalancemod1,setleavebalancemod1] = useState("")
  const [labelleavebalancemod1,setlabelleavebalancemod1] = useState("")
  const [borderleavebalancemod1,setborderleavebalancemod1] = useState("")
  
  const [cumulativemod1,setcumulativemod1] = useState("")
  const [labelcumulativemod1,setlabelcumulativemod1] = useState("")
  const [bordercumulativemod1,setbordercumulativemod1] = useState("")

  const [activefrommod1,setactivefrommod1] = useState("")
  const [borderactivefrommod1,setborderactivefrommod1] = useState("")
  const [labelactivefrommod1,setlabelactivefrommod1] = useState("")

  const [activetomod1,setactivetomod1] = useState("")
  const [borderactivetomod1,setborderactivetomod1] = useState("")
  const [labelactivetomod1,setlabelactivetomod1] = useState("")

  const [leavetypemod2,setleavetypemod2] = useState("")
  const [labelleavetypemod2,setlabelleavetypemod2] = useState("")
  const [borderleavetypemod2,setborderleavetypemod2] = useState("")

  const [descriptionmod2,setdescriptionmod2] = useState("")
  const [labeldescriptionmod2,setlabeldescriptionmod2] = useState("")
  const [borderdescriptionmod2,setborderdescriptionmod2] = useState("")

  const [designationmod2,setdesignationmod2] = useState("")
  const [borderdesignationmod2,setborderdesignationmod2] = useState("")
  const [labeldesignationmod2,setlabeldesignationmod2] = useState("")

  const [noofmonthmod2,setnoofmonthmod2] = useState("")
  const [labelnoofmonthmod2,setlabelnoofmonthmod2] = useState("")
  const [bordernoofmonthmod2,setbordernoofmonthmod2] = useState("")

  const [leavebalancemod2,setleavebalancemod2] = useState("")
  const [labelleavebalancemod2,setlabelleavebalancemod2] = useState("")
  const [borderleavebalancemod2,setborderleavebalancemod2] = useState("")
  
  const [cumulativemod2,setcumulativemod2] = useState("")
  const [labelcumulativemod2,setlabelcumulativemod2] = useState("")
  const [bordercumulativemod2,setbordercumulativemod2] = useState("")

  const [activefrommod2,setactivefrommod2] = useState("")
  const [borderactivefrommod2,setborderactivefrommod2] = useState("")
  const [labelactivefrommod2,setlabelactivefrommod2] = useState("")

  const [activetomod2,setactivetomod2] = useState("")
  const [borderactivetomod2,setborderactivetomod2] = useState("")
  const [labelactivetomod2,setlabelactivetomod2] = useState("")
 
 const drpfunctioncumulativemod1=(myval,myid)=>{
  setcumulativemod1(myval)
 }
 const drpfuncdesignationmod1=(myval,myid)=>{
  setdesignationmod1(myval)
 }
 const drpfunctionleavetypemod1=(myval,myid)=>{
  setleavetypemod1(myval)
 }

 const handleactivefrommod1 = (activefromval)=>{

  if(activefromval != null){
    
      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
     
      setactivefrommod1(moment(dtfinalc).format("YYYY-MM-DD"))
  }  
}
const handleactivetomod1 = (activefromval)=>{

  if(activefromval != null){
    
      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
     
      setactivetomod1(moment(dtfinalc).format("YYYY-MM-DD"))
  }
  
}

 const drpfunctioncumulativemod2=(myval,myid)=>{
    setcumulativemod2(myval)
   }
   const drpfuncdesignationmod2=(myval,myid)=>{
    setdesignationmod2(myval)
   }
   const drpfunctionleavetypemod2=(myval,myid)=>{
    setleavetypemod2(myval)
   }
  
   const handleactivefrommod2 = (activefromval)=>{
  
    if(activefromval != null){
      
        var dtmnt = activefromval.$M + 1;
        var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
       
        setactivefrommod2(moment(dtfinalc).format("YYYY-MM-DD"))
    }  
  }
  const handleactivetomod2 = (activefromval)=>{
  
    if(activefromval != null){
      
        var dtmnt = activefromval.$M + 1;
        var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
       
        setactivetomod2(moment(dtfinalc).format("YYYY-MM-DD"))
    }
    
  }
 
  const handleShow = () => setShow2(true);
 
  const [newArr,setNewArr] = useState([])
  const [classresponse, setclassresponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);
            // console.log(classresponse);
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    };
    fetchClassDropdown();
}, []);
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")

  const [classdrp,setClassdrp] = useState("")
  
  const drpfuncClass=(myval,myid)=>{
    setClassdrp(myid)    
  }
    const [show3, setShow3] = useState(false);

    const handleClose2=()=>{
      setShow3(false)
    }
    const [modalitem,setmodalitem] = useState(null)
    const handleShow3 = (e,myitem) =>{
      setShow3(true)
      setmodalitem(myitem)
      
    
    };
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(leaveSetupApi.data)


  const mainfilter=(arr)=>{    
 

    setfilteredArr(arr);
    
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;        
        setCurrentItems(leaveSetupApi.data.slice(itemOffset, endOffset));        
        setPageCount(Math.ceil(leaveSetupApi.data.length / itemsPerPage));
        
      }, [itemOffset, itemsPerPage]);
      let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
      useEffect(()=>{
        const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
        settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
        setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
        setpagecountoffilter(filteredArr.length)
      },[itemOffsetfiltered,itemsPerPagefiltered,filteredArr,tempfilteredarr])
    
      // Invoke when user click to request another page.
      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % leaveSetupApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      const handleClose=()=>{
        setShow2(false)
      }
     



    
      
      const handlesearch =()=>{
    
        setactivefrom("")
      
    }

    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
    const handleModaleditsave=()=>{
    
      setShow3(false)
    }

   
   

    useEffect(()=>{
      
        mainfilter(leaveSetupApi.data)      

      
    },[])
    
    const handleActiveFrom = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom(dtfinalc)
        }
        
        
    }
   
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo(dtfinalc)

            
        }
        
        
    }
  
  
    // Modal2activefromto 
   
   



    // Validation 

    const handlesaveModal1 = ()=>{
    
      validationDrp(leavetypemod1,setlabelleavetypemod1,setborderleavetypemod1,"Leave Type Required")
      validationComp(descriptionmod1,setlabeldescriptionmod1,setborderdescriptionmod1,"Description Required")
      validationDrp(designationmod1,setlabeldesignationmod1,setborderdesignationmod1,"Designation Required")
      validationComp(noofmonthmod1,setlabelnoofmonthmod1,setbordernoofmonthmod1,"No Of Month Required")
      validationComp(leavebalancemod1,setlabelleavebalancemod1,setborderleavebalancemod1,"Leave Balance Required")
      validationDrp(cumulativemod1,setlabelcumulativemod1,setbordercumulativemod1,"Cumulative Required")
      validationDrp(activefrommod1,setlabelactivefrommod1,setborderactivefrommod1,"Active From Rquired")
      validationDrp(activetomod1,setlabelactivetomod1,setborderactivetomod1,"Active To Rquired")
    }
   
    const handlesaveModal2 = ()=>{
    
      validationDrp(leavetypemod2,setlabelleavetypemod2,setborderleavetypemod2,"Leave Type Required")
      validationComp(descriptionmod2,setlabeldescriptionmod2,setborderdescriptionmod2,"Description Required")
      validationDrp(designationmod2,setlabeldesignationmod2,setborderdesignationmod2,"Designation Required")
      validationComp(noofmonthmod2,setlabelnoofmonthmod2,setbordernoofmonthmod2,"No Of Month Required")
      validationComp(leavebalancemod2,setlabelleavebalancemod2,setborderleavebalancemod2,"Leave Balance Required")
      validationDrp(cumulativemod2,setlabelcumulativemod2,setbordercumulativemod2,"Cumulative Required")
      validationDrp(activefrommod2,setlabelactivefrommod2,setborderactivefrommod2,"Active From Rquired")
      validationDrp(activetomod2,setlabelactivetomod2,setborderactivetomod2,"Active To Rquired")
    }
    const handleClose3=()=>{
      setShow3(false)
    }

    // start
  return (
    <div className="d-flex flexvaluecomp">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Leave Setup"/>
          <div className="contentofadmindash contentflexvalue">
            <Row>
                <Col lg={8} className="m-auto">
                <Row>
                    <Col lg={4}>
                        <div className="basicinput">
                            <p></p>
                            <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus />New Leave Setup</button>
                        </div>
                    </Col>
                    
                    <Col lg={4}>
                    <div className="basicinput">
                    <p>Active from</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrom}
                          onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                    </Col>
                    <Col lg={4}>
                    <div className="basicinput">
                    <p>Active To</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activeto}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                    </Col>
                   
                </Row>
                
                </Col>
            </Row>
              <Row style={{marginTop:"20px"}}>
                <Col className="m-auto" lg={4}>
                  <Row>
                    <Col lg={3}>
                    <div className="basicinput">
                      <p>Show</p>
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                      </div>
                      </div>
                    </Col>
                    <Col lg={9}>
                            <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={(e)=>setmainpagesearch(e.target.value)}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col lg={12} className="m-auto">
                  <div className="flexvaluetable leavesetuptable">
                    <table>
                      <thead>
                        <tr>
                            {
                              leaveSetupApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.id}</td>
                                  <td>{item.type}</td>
                                  <td>{item.description}</td>
                                  <td>{item.designaiton}</td>
                                  <td>{item.noofmonth}</td>
                                  <td>{item.leavebalance}</td>
                                  <td>{item.cumulative}</td>
                                  <td>{item.activeFrom}</td>
                                  <td>{item.activeTo}</td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {leaveSetupApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>

               {/* modal1ori */}

              <Modal dialogClassName="mymodalclsSubjectAdmin" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Leave Setup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                      
                      <Col lg={6} className='pr7'>
                        <div className="basicinputfield h40p">
                        <p>Leave Type</p>
                        <div className="inputgap h40">
                            <div className="dropdownwrapper">
                                <Dropdown2 err={borderleavetypemod1} func={drpfunctionleavetypemod1} myplaceholder={leavetypemod1 }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsleavetype} />
                            </div>
                            <label>{labelleavetypemod1}</label>
                            </div>
                        </div>
                      </Col>
                      <Col lg={6} className="pl7">
                      <div className="basicinputfield h40p">
                            <p>Description</p>
                            <div className="inputgap h40">
                            <input style={borderdescriptionmod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={descriptionmod1} onChange={(e) => setdescriptionmod1(e.target.value)} />
                            <label>{labeldescriptionmod1}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pr7">
                    <div className="basicinputfield h40p ">

                    <p>Designaiton</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderdesignationmod1} func={drpfuncdesignationmod1} myplaceholder={designationmod1}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                        </div>
                        <label>{labeldesignationmod1}</label>
                        </div>
                    </div>
                    </Col>
                     <Col lg={6} className="pl7">
                      <div className="basicinputfield h40p">
                            <p>No of Month</p>
                            <div className="inputgap h40">
                            <input style={bordernoofmonthmod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={noofmonthmod1} onChange={(e) => setnoofmonthmod1(e.target.value)} />
                            <label>{labelnoofmonthmod1}</label>
                            </div>
                        </div>
                    </Col>
                     <Col lg={6} className="pr7">
                      <div className="basicinputfield h40p">
                            <p>Leave Balance</p>
                            <div className="inputgap h40">
                            <input style={borderleavebalancemod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={leavebalancemod1} onChange={(e) => setleavebalancemod1(e.target.value)} />
                            <label>{labelleavebalancemod1}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className='pl7'>
                        <div className="basicinputfield h40p">
                        <p>Cumulative</p>
                        <div className="inputgap h40">
                            <div className="dropdownwrapper">
                                <Dropdown2 err={bordercumulativemod1} func={drpfunctioncumulativemod1} myplaceholder={cumulativemod1 }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionscumulative} />
                            </div>
                            <label>{labelcumulativemod1}</label>
                            </div>
                        </div>
                      </Col>
                      <Col lg={6} className=" pr7">
                        <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommod1}
                              onChange={(newvaldob)=>handleactivefrommod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                        <Col lg={6} className="pl7">
                        <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomod1}
                              onChange={(newvaldob)=>handleactivetomod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active To"
                                }} error={false} />}
                          />
                          <label>{labelactivetomod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>

                {/* modal2ori */}
              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Leave Setup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                      
                      <Col lg={6} className='pr7'>
                        <div className="basicinputfield h40p">
                        <p>Leave Type</p>
                        <div className="inputgap h40">
                            <div className="dropdownwrapper">
                                <Dropdown2 err={borderleavetypemod2} func={drpfunctionleavetypemod2} myplaceholder={leavetypemod2 }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsleavetype} />
                            </div>
                            <label>{labelleavetypemod2}</label>
                            </div>
                        </div>
                      </Col>
                      <Col lg={6} className="pl7">
                      <div className="basicinputfield h40p">
                            <p>Description</p>
                            <div className="inputgap h40">
                            <input style={borderdescriptionmod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={descriptionmod2} onChange={(e) => setdescriptionmod2(e.target.value)} />
                            <label>{labeldescriptionmod2}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pr7">
                    <div className="basicinputfield h40p ">

                    <p>Designaiton</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderdesignationmod2} func={drpfuncdesignationmod2} myplaceholder={designationmod2}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                        </div>
                        <label>{labeldesignationmod2}</label>
                        </div>
                    </div>
                    </Col>
                     <Col lg={6} className="pl7">
                      <div className="basicinputfield h40p">
                            <p>No of Month</p>
                            <div className="inputgap h40">
                            <input style={bordernoofmonthmod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={noofmonthmod2} onChange={(e) => setnoofmonthmod2(e.target.value)} />
                            <label>{labelnoofmonthmod2}</label>
                            </div>
                        </div>
                    </Col>
                     <Col lg={6} className="pr7">
                      <div className="basicinputfield h40p">
                            <p>Leave Balance</p>
                            <div className="inputgap h40">
                            <input style={borderleavebalancemod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={leavebalancemod2} onChange={(e) => setleavebalancemod2(e.target.value)} />
                            <label>{labelleavebalancemod2}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className='pl7'>
                        <div className="basicinputfield h40p">
                        <p>Cumulative</p>
                        <div className="inputgap h40">
                            <div className="dropdownwrapper">
                                <Dropdown2 err={bordercumulativemod2} func={drpfunctioncumulativemod2} myplaceholder={cumulativemod2 }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionscumulative} />
                            </div>
                            <label>{labelcumulativemod2}</label>
                            </div>
                        </div>
                      </Col>
                      <Col lg={6} className=" pr7">
                        <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommod2}
                              onChange={(newvaldob)=>handleactivefrommod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                        <Col lg={6} className="pl7">
                        <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomod2}
                              onChange={(newvaldob)=>handleactivetomod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active To"
                                }} error={false} />}
                          />
                          <label>{labelactivetomod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose3}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Update
                  </button>
                </Modal.Footer>
              </Modal>
              </div>
              </div>
              </div>
  )
}

export default LeaveSetupComp